import {Component, OnChanges, Output, EventEmitter, Input} from '@angular/core';

import { Rule, RuleCategory, Package } from '../services/capd.model';
import { RulesService } from '../services/rules.service';
import { PackageService } from '../services/package.service';

@Component({
  selector: 'package-rule-tray',
  templateUrl: './package-rule-tray.component.html',
  // inputs: ['selectedPack', 'changed']
})

export class PackageRuleTrayComponent implements OnChanges{

  @Output() packChange: EventEmitter<any> = new EventEmitter();
  @Output() ruleDetail: EventEmitter<any> = new EventEmitter();
  rules: Rule[];
  toAdd: Rule[] = [];
  categories: string[];
  @Input()selectedPack: Package;
  relational: RuleCategory[];
  countRules = 0;
  @Input()changed: boolean;

  constructor(
    private _service: RulesService,
    private _packService: PackageService
  ) {}

  /**
   * Gets the packages and the rules, and
   *
   * @async
   * @func ngOnChanges
   */
  ngOnChanges() {
    this._service.getPackageRules(this.selectedPack).then((rules: Rule[]) => {
      this.rules = rules;
      this.countRules = rules.length;
      this._service.getCategories().then((categories: string[]) => {
        this.categories = categories;
        this.relational = new Array<RuleCategory>(0);
        // See https://stackoverflow.com/questions/44303616/typescript-how-to-access-component-variable-in-foreach-loop/44303675
        categories.forEach(category => {
          const subRules = this.rules.filter(rule => category === rule.triggerCategory);
          if (subRules.length > 0) {
            subRules.forEach(subRule => {
              if (!subRule.triggerName) {
                subRule.triggerName = subRule.triggerCode;
              }
            });
            this.relational.push(new RuleCategory(category, subRules.sort((a, b) => a.triggerName.localeCompare(b.triggerName)), 'Select all'));
          }
        });

      });
    });
  }

  /**
   * When a rule is selected, it sends back a signal to the parent so that it can open the rule detail window.
   * Shared with detail component.
   *
   * @func selectRule
   * @param {Rule} rule - the rule to select.
   */
  selectRule(rule: Rule) {
    console.log("Emitting Rule: ", rule);
    this.ruleDetail.emit(rule);
  }

  /**
   * Selects everything in a particular category to add.
   *
   * @func toggleSelectAll
   * @param {string} category - the name of the category whose rules you wish to add.
   */
  toggleSelectAll(category) {
    const index = this.relational.indexOf(category);
    if (index >= 0) {
      if (this.relational[index].selText === 'Select all') {
        this.relational[index].members.forEach(rule => this.addRule(rule));
      }
      else {
        this.relational[index].members.forEach(rule => this.removeRule(rule));
      }
    }
    this.checkCategory(category.triggerCategory);
  }

  /**
   * Every time you check or uncheck a box, this function is called.
   *
   * @func onSelect
   * @param {Rule} rule - the selected rule.
   */
  onSelect(rule) {
    const index = this.toAdd.indexOf(rule);
    if (index < 0) {
      this.addRule(rule);
    }
    else {
      this.removeRule(rule);
    }
    this.checkCategory(rule.triggerCategory);
  }

  /**
   * This function checks if a rule is already in the list of rules to be added.
   * If it's not, it adds the rule in question to the end of the array.
   *
   * @func addRule
   * @param {Rule} rule - the rule to add.
   */
  addRule(rule) {
    const index = this.toAdd.indexOf(rule);
    if (index < 0 && !!rule.action.actionType) {
      this.toAdd.push(rule);
    }
  }

  /**
   * This function attempts to find a rule in the list to be added and,
   * if it's found, removes it.
   *
   * @func removeRule
   * @param {Rule} rule - the rule to remove.
   */
  removeRule(rule) {
    const index = this.toAdd.indexOf(rule);
    if (index >= 0) {
      this.toAdd.splice(index, 1);
    }
  }

  /**
   * Every time a rule is added or removed, this function is called.
   * If you manually selected every rule in a category, it changes the add toggle to "Deselect all."
   * Else, it keeps the text as "Select all."
   *
   * @func checkCategory
   * @param {string} cat - the category being checked.
   */
  checkCategory(cat) {
    let index = -1;
    for (let i = 0; i < this.relational.length; i++) {
      if (this.relational[i].triggerCategory === cat) {
        index = i;
        break;
      }
    }
    if (index >= 0) {
      for (let i = 0; i < this.relational[index].members.length; i++) {
        if (this.toAdd.indexOf(this.relational[index].members[i]) < 0) {
          this.relational[index].selText = 'Select all';
          return;
        }
      }

      this.relational[index].selText = 'Deselect all';
    }
  }

  /**
   * Submits the package. it takes the list to add as an argument, as it can either add everything
   * in the library or just rules selected to add.
   *
   * @async
   * @func submitPackage
   * @param {Rule[]} listToAdd - the list of rules to add to a package.
   */
  submitPackage(listToAdd) {
    this._packService.addRulesToPackage(this.selectedPack, listToAdd).then(() => {
      this.toAdd = [];
      this.rules = [];
      this.packChange.emit(null);
      this.ngOnChanges();
    });
  }

  getChecked(rule) {
    return this.toAdd.findIndex(r => r.triggerCode == rule.triggerCode && r.triggerName == rule.triggerName) >= 0
  }
}
